import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import { useStyles } from '../../../styles';
import '../../../styles/projectHeader.css';

interface ProjectsHeaderProps {
  projectCount: number;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAddProject: () => void;
  isToolAdmin: boolean;
}

export const ProjectsHeader = ({
  projectCount,
  searchQuery,
  onSearchChange,
  onAddProject,
  isToolAdmin,
}: ProjectsHeaderProps) => {
  const classes = useStyles();
  const isMobile = useMediaQuery<Theme>(theme => theme.breakpoints.down('sm'), {
    noSsr: true,
  });

  return (
    <Box
      component="header"
      className={`projects-header ${classes.projectsHeaderRoot}${
        isMobile ? ' projects-header-mobile' : ''
      }`}
    >
      <Typography
        variant="h5"
        align={isMobile ? 'left' : undefined}
        className={`${classes.projectsHeaderTitle} projects-header-title${
          isMobile ? ' projects-header-title-mobile' : ''
        }`}
      >
        {`Projects (${projectCount})`}
      </Typography>

      <Box
        className={`projects-header-controls${
          isMobile ? ' projects-header-controls-mobile' : ''
        }`}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search projects"
          value={searchQuery}
          onChange={e => onSearchChange(e.target.value)}
          className="projects-header-search"
          inputProps={{ 'aria-label': 'Search projects' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {/* typography resets + height + shadow in projectHeader.css */}
        <Button
          variant="contained"
          color="primary"
          className="projects-header-add-btn"
          onClick={onAddProject}
          aria-label="Add a new project"
          disabled={!isToolAdmin}
        >
          Add new Project
        </Button>
      </Box>
    </Box>
  );
};
